import { ECategoryType, ESubcategoryType } from "../Products/IProductDetail";

export interface INewUser {
  id: number;
  name: string;
  document_nr: string;
  email: string;
  cell_phone: string;
  password: string;
  status: boolean;
  certificate_nr: string;
  address_id: number;
  address: IAddress;
  profile_id: number;
  created_at: Date;
  profile: IProfile[];
  organization_id: number;
  organization: IOrganization;
  manager_id: number;
  manager: Manager;
  products: Product[];
  secondaryEmails: ISecondaryEmail[];
  machine_name: string;
  machine_ip: string;
  display_name: string;
  isPasswordExpired: boolean;
  notifications: INotification;
  role: ERole[];
  has_active_plan: boolean;
}

export enum ERole {
  admin = "Admin",
  analyst = "Analista",
  client = "Cliente",
}
export interface IProfile {
  id: number;
  name: ERole;
  is_default: boolean;
}
export interface IAddress {
  id: number;
  city: string;
  state: string;
  cep: string;
  additional_address: string;
  country: string;
  number: string;
  street: string;
  neighborhood: string;
}

export interface Manager {
  id: number;
  name: string;
  document_nr: string;
  email: string;
  cell_phone: string;
  password: string;
  status: boolean;
  certificate_nr: string;
  address_id: number;
  address: IAddress;
  profile_id: number;
  profile: IProfile;
  organization_id: number;
  organization: IOrganization;
  manager_id: number;
  manager: string;
  products: Product[];
  secondaryEmails: ISecondaryEmail[];
  machine_name: string;
  machine_ip: string;
  display_name: string;
}

export interface IOrganization {
  id: number;
  name: string;
  short_name: string;
  documents_nr: string;
  type_of_organization: string;
  drop_copy: boolean;
  share_customer_info: boolean;
  address_id: IAddress;
  logo_id: IImage;
  icon_id: IImage;
  departments: Department[];
}

export interface Department {
  id: number;
  departament: string;
}

export interface IImage {
  id: number;
  filename: string;
  path: string;
  name: string;
  fieldname: string;
  originalname: string;
  encoding: string;
  mimetype: string;
  ServerSideEncryption: string;
  ETag: string;
  width: number;
  height: number;
  premultiplied: boolean;
  size: number;
  ContentType: string;
  url: string;
  Bucket: string;
  ACL: string;
  key: string;
  Key: string;
  Location: string;
  organizations: string[];
}

export interface Product {
  id: number;
  title: string;
  short_description: string;
  detailed_description: string;
  term_of_contract_id: number;
  term_of_contract: IImage;
  category: ECategoryType;
  subcategory: ESubcategoryType;
  analyst_user_id: number;
  analyst_user: string;
  analyst_broker_id: number;
  analyst_broker: IOrganization;
  analyst_broker_account: string;
  analyst_certificate_nr: string;
  market: string;
  whitelabel_id: number;
  whitelabel: IWhitelabel;
  marketplace_type: number;
  emphasis: boolean;
  active: boolean;
  dashboard_analyst: boolean;
  dashboard_client: boolean;
  desktop: boolean;
  mobile: boolean;
  web: boolean;
  is_demo: boolean;
  is_real: boolean;
  photo_id: number;
  photo: IImage;
  icon_id: number;
  icon: IImage;
  platforms_id: number;
  platforms: IPlatforms;
  organizations: IOrganization[];
  instruments: IInstrument[];
  type: string;
  created_at: Date;
  updated_at: Date;
  plans: Plan[];
  faq: FAQ[];
  has_reverse_order: boolean;
}

export interface FAQ {
  id: number;
  question: string;
  answer: string;
}

export interface IInstrument {
  id: number;
  name: string;
  symbol: string;
  is_this: boolean;
  refers_type: number;
  quote_factor: number;
  expiration_date: Date;
}

export interface Plan {
  id: number;
  product_id: number;
  product: string;
  name: string;
  qty_contract: number;
  price: number;
  active: boolean;
  vindi_id: number;
  is_recurrency: boolean;
  recurrency_type: string;
  is_visible_on_marketplace: boolean;
  created_at: Date;
  updated_at: Date;
  user_plans: UserPlan[];
}

export interface UserPlan {
  id: number;
  user_id: number;
  user: string;
  plan_id: number;
  plan: string;
  status: string;
  is_partner_subscription: boolean;
  seller_id: number;
  seller: IOrganization;
  buy_date: Date;
  expire_date: Date;
  max_wait_renewal_date: Date;
  is_accepted_term: boolean;
  accepted_term_date: Date;
  is_machine_running: boolean;
  qty: number;
  is_inverse_side: boolean;
  is_algorithm_running: boolean;
  machine_last_state: Date;
  algorithm_last_state: Date;
  whitelabel_id: number;
  whitelabel: IWhitelabel;
  vindi_subscription_id: number;
  vindi_customer_id: number;
  billing_history: IBillingHistory[];
  broker_integration_id: number;
  broker_integration: IBrokerIntegration;
  last_change_config: Date;
}

export interface IBillingHistory {
  id: number;
  user_plan_id: number;
  user_plan: string;
  payment_owner_name: string;
  payment_owner_document_nr: string;
  payment_owner_zipcode: string;
  credit_card_last_four: number;
  debit_amount: number;
  vindi_payment_profile_id: number;
  vindi_transaction_id: number;
  vindi_bill_code: string;
  vindi_attempt_count: number;
  vindi_payment_status: string;
  vindi_transaction_gateway_message: string;
  vindi_next_attempt: Date;
}

export interface IBrokerIntegration {
  id: number;
  broker_id: number;
  broker: IOrganization;
  customer_trade_account: string;
  customer_id: string;
  customer_name: string;
  customer_email: string;
  customer_document_nr: string;
  customer_cell_phone: string;
  customer_friendly_account: string;
  active: boolean;
  status: string;
  user_id: number;
  user: string;
  created_at: Date;
  updated_at: Date;
}

export interface IWhitelabel {
  id: number;
  name: string;
  exclusive_marketplace: boolean;
  url_login: string;
  url_signup: string;
  url_resend_email: string;
  organization_id: number;
  organization: IOrganization;
}

export interface IPlatforms {
  id: number;
  windows: boolean;
  mac: boolean;
  android: boolean;
  chrome: boolean;
  firefox: boolean;
  opera: boolean;
  safari: boolean;
  edge: boolean;
  ios: boolean;
}

export interface ISecondaryEmail {
  id: number;
  email: string;
  is_active: boolean;
  user_id: number;
  user: string;
  created_at: Date;
  updated_at: Date;
}

export interface INotification {
  id?: number;
  broker_id?: number;
  email_scheduled_user_plan_action: boolean;
  email_executed_user_plan_action: boolean;
  email_new_order_sent: boolean;
}

export interface IFormUser {
  cell_phone: string;
  name?: string;
  document_nr?: string;
  email?: string;
  display_name?: string;
  address: {
    id?: number;
    city: string;
    state: string;
    cep: string;
    additional_address: string;
    country: string;
    number: string;
    street: string;
    neighborhood: string;
  };
  secondary_emails: ISecondaryEmail[];
  client_ip: string;
  notifications: INotification;
}

export type IFormChangePassword = {
  old_password: string;
  new_password: string;
  second_new_password: string;
};
